<template>
  <v-layout align-start v-resize="getDimensions">
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row v-if="mostrarBusquedas">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchParamCodigo"
                append-icon="search"
                label="Búsqueda por código"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchParamDescripcion"
                append-icon="search"
                label="Búsqueda por descripción"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="6" md="6">
              <v-toolbar-title class="font-weight-black primary--text"
                >Cargo</v-toolbar-title
              >
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarBusqueda"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ mostrarBusquedas ? "search_off" : "search" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              mostrarBusquedas
                ? "Ocultar filtros de búsqueda"
                : "Mostrar filtros de búsqueda"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarInactivos"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ !inactivos ? "visibility_off" : "visibility" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              !inactivos ? "Ocultar Inactivos" : "Mostrar Inactivos"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              :loading="load"
              @click="exportarExcel"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> fa-solid fa-file-excel </v-icon>
            </v-btn>
          </template>
          <span>Exportar a Excel</span>
        </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarCarga"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> file_upload </v-icon>
              </v-btn>
            </template>
            <span>Carga masiva de datos</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="agregar"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> add </v-icon>
              </v-btn>
            </template>
            <span>Ingresar nuevo registro</span>
          </v-tooltip>
        </v-app-bar>
        <v-sheet class="overflow-y-auto" :max-height="height + 160">
          <v-data-table
            dense
            fixed-header
            :height="height - 210"
            :headers="headers"
            :items="dtCargos"
            :items-per-page="2"
            sort-by="codigo"
            class="elevation-1"
            :loading="dtCargosLoad"
            loading-text="Cargando... Espere por favor"
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'items-per-page-options': [30, 100, 150, 200, -1],
            }"
          >
            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'I'">
                <v-btn
                  color="error"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  color="success"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:[`item.codigo`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    text
                    dark
                    color="primary"
                    class="font-weight-bold"
                    @click="editar(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.codigo }}
                  </v-btn>
                </template>
                <span>Editar cargo</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.centro_costo`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    text
                    dark
                    color="primary"
                    @click="editarCentroCostos(item)"
                    v-bind="attrs"
                    v-on="on"
                    :class="
                      item.centro_costo == null
                        ? 'error--text font-weight-bold'
                        : 'primary--text font-weight-bold'
                    "
                  >
                    {{
                      item.centro_costo === null
                        ? "NO DEFINIDO"
                        : item.centro_costo
                    }}
                  </v-btn>
                </template>
                <span>Editar Centro de Costo</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.cupo`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    text
                    dark
                    color="primary"
                    @click="editarCupos(item)"
                    v-bind="attrs"
                    v-on="on"
                    :class="
                      item.cupo === 0
                        ? 'error--text font-weight-bold'
                        : 'primary--text font-weight-bold'
                    "
                  >
                    {{
                      item.cupo === 0
                        ? "Sin cupos"
                        : item.cupo.toString() +
                          (item.cupo === 1 ? " cupo" : " cupos")
                    }}
                  </v-btn>
                </template>
                <span>Editar Cupos</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.area`]="{ item }">
              <div v-if="item.area == 'NO DEFINIDO'" class="error--text">
                {{ item.area }}
              </div>
              <div v-else>
                {{ item.area }}
              </div>
            </template>

            <template v-slot:[`item.subarea`]="{ item }">
              <div v-if="item.subarea == 'NO DEFINIDO'" class="error--text">
                {{ item.subarea }}
              </div>
              <div v-else>
                {{ item.subarea }}
              </div>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="listar">Cargar</v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
      <v-dialog v-model="dialogCargaExcel" max-width="40%">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga Masiva de Datos</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCarga"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="attach_file"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="guardarExcel"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar archivo</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogActivacion" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estado == "A" ? "desactivará" : "activará" }} el
            elemento seleccionado.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogActivacion = false">Cancelar</v-btn>
            <div v-if="estado == 'A'">
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogForm" max-width="650px" persistent>
        <v-card ref="form">
          <v-system-bar color="error" dark v-if="!(porcentajeCco === 100)">
            <v-icon> warning </v-icon>
            <v-spacer></v-spacer>
            No se ha asignado el 100% de los Centros de Costo.
          </v-system-bar>
          <v-system-bar color="error" dark v-if="cupo === 0">
            <v-icon> warning </v-icon>
            <v-spacer></v-spacer>
            El cargo no tiene cupos asignados.
          </v-system-bar>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="editarAntiguoCargo()"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> fa-solid fa-arrows-down-to-people </v-icon>
                </v-btn>
              </template>
              <span>Actualizar Cargo</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="editarCentroCostos()"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> fa-solid fa-briefcase </v-icon>
                </v-btn>
              </template>
              <span>Asignar Centros de Costo</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="editarCupos()"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> fa-solid fa-users </v-icon>
                </v-btn>
              </template>
              <span>Asignar Cupos</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="guardar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> fa-solid fa-save </v-icon>
                </v-btn>
              </template>
              <span>Guardar Cargo</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> fa-solid fa-xmark </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="codigo"
                    v-model="codigo"
                    :readonly="!editarCodigo"
                    :rules="[$rules.requerido, $rules.max10]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Código"
                    placeholder="Código"
                    required
                  ></v-text-field>

                  <v-textarea
                    outlined
                    dense
                    :rows="2"
                    ref="descripcion"
                    v-model="descripcion"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    :rules="[$rules.requerido, $rules.min2]"
                    :error-messages="errorMessages"
                    label="Descripción"
                    placeholder="Descripción"
                    required
                  ></v-textarea>

                  <v-autocomplete
                    outlined
                    dense
                    ref="id_area"
                    v-model="id_area"
                    :items="areaList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    @change="selectSubarea"
                    item-text="descripcion"
                    item-value="id"
                    label="Área"
                    required
                  ></v-autocomplete>

                  <v-autocomplete
                    outlined
                    dense
                    ref="id_subarea"
                    v-model="id_subarea"
                    :items="subareaList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Subárea"
                    required
                  ></v-autocomplete>

                  <v-autocomplete
                    outlined
                    dense
                    ref="id_area_presupuesto"
                    v-model="id_area_presupuesto"
                    :items="areaPresupList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Area Presupuesto"
                    required
                  ></v-autocomplete>

                  <v-text-field
                    outlined
                    reverse
                    dense
                    ref="salario_ref"
                    v-model="salario_ref"
                    :rules="[$rules.numero]"
                    :error-messages="errorMessages"
                    label="Salario Referencial"
                    required
                  ></v-text-field>
                  <v-text-field
                    outlined
                    dense
                    reverse
                    ref="base_premio"
                    v-model="base_premio"
                    :rules="[$rules.numero]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Base de Premio"
                    placeholder="Base de Premio"
                    required
                  ></v-text-field>
                  <v-text-field
                    outlined
                    dense
                    reverse
                    ref="nivel"
                    v-model="nivel"
                    :rules="[$rules.numero]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Nivel"
                    placeholder="Nivel"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFormCentroCostos" max-width="650px" persistent>
        <v-card ref="form">
          <v-system-bar color="error" dark v-if="cupo === 0">
            <v-icon> warning </v-icon>
            <v-spacer></v-spacer>
            No se han asignado centros de costo para el Cargo seleccionado.
          </v-system-bar>
          <v-app-bar color="white" elevate-on-scroll flat>
            <span>{{ "CENTROS DE COSTO PARA " + descripcion }} </span>

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="agregarCentroCosto"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> add </v-icon>
                </v-btn>
              </template>
              <span>Agregar Centro de Costo</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCentroCosto"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Volver</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-card class="overflow-hidden" v-show="esEditado">
              <v-sheet class="overflow-y-auto" :max-height="height + 110">
                <v-data-table
                  dense
                  fixed-header
                  :height="height - 240"
                  :headers="headersCentroCosto"
                  :items="dtCentroCostos"
                  :items-per-page="2"
                  class="elevation-1"
                  :header-props="{
                    'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                  }"
                  :footer-props="{
                    'items-per-page-text': 'Filas por página',
                    'items-per-page-options': [-1, 100, 150, 200],
                  }"
                >
                  <template v-slot:[`item.opciones`]="{ item }">
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            icon
                            dark
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="deleteItemCentroCosto(item)"
                          >
                            <v-icon x-small>delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar Centro de Costo</span>
                      </v-tooltip>
                    </div>
                  </template>

                  <template v-slot:no-data>
                    <span>No se encontraron registros</span>
                  </template>
                </v-data-table>
              </v-sheet>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFormUniformes" max-width="650px" persistent>
        <v-card ref="form">
          <v-system-bar color="error" dark v-if="cupo === 0">
            <v-icon> warning </v-icon>
            <v-spacer></v-spacer>
            No se han asignado centros de costo para el Cargo seleccionado.
          </v-system-bar>
          <v-app-bar color="white" elevate-on-scroll flat>
            <span>{{ "Uniformes para " + descripcion }} </span>

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="agregarUniforme"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> fa-solid fa-vest-patches </v-icon>
                </v-btn>
              </template>
              <span>Agregar Uniforme</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCentroCosto"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Volver</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-card class="overflow-hidden" v-show="esEditado">
              <v-sheet class="overflow-y-auto" :max-height="height + 110">
                <v-data-table
                  dense
                  fixed-header
                  :height="height - 240"
                  :headers="headersUniforme"
                  :items="dtUniformes"
                  :items-per-page="2"
                  class="elevation-1"
                  :header-props="{
                    'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                  }"
                  :footer-props="{
                    'items-per-page-text': 'Filas por página',
                    'items-per-page-options': [-1, 100, 150, 200],
                  }"
                >
                  <template v-slot:[`item.opciones`]="{ item }">
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            icon
                            dark
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="deleteItemCentroCosto(item)"
                          >
                            <v-icon x-small>delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar Centro de Costo</span>
                      </v-tooltip>
                    </div>
                  </template>

                  <template v-slot:no-data>
                    <span>No se encontraron registros</span>
                  </template>
                </v-data-table>
              </v-sheet>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFormCupos" max-width="650px" persistent>
        <v-card ref="form">
          <v-system-bar color="error" dark v-if="cupo === 0">
            <v-icon> warning </v-icon>
            <v-spacer></v-spacer>
            No se han asignado cupos para el Cargo seleccionado.
          </v-system-bar>
          <v-app-bar color="white" elevate-on-scroll flat>
            <span>{{ "CUPOS PARA " + descripcion }} </span>

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-
                  icon
                  large
                  @click="agregarCupo"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> add </v-icon>
                </v->
              </template>
              <span>Agregar Cupo</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCupo"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Volver</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-card class="overflow-hidden" v-show="esEditado">
              <v-sheet class="overflow-y-auto" :max-height="height + 110">
                <v-data-table
                  dense
                  fixed-header
                  :height="height - 240"
                  :headers="headersCupo"
                  :items="dtCupos"
                  :items-per-page="2"
                  class="elevation-1"
                  :header-props="{
                    'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                  }"
                  :footer-props="{
                    'items-per-page-text': 'Filas por página',
                    'items-per-page-options': [-1, 100, 150, 200],
                  }"
                >
                  <template v-slot:[`item.nom_persona_actual`]="{ item }">
                    <div
                      class="error--text"
                      v-if="item.cod_persona_actual === null"
                    >
                      {{ "NO ASIGNADO" }}
                    </div>
                    <div v-else>
                      {{
                        item.cod_persona_actual +
                        " - " +
                        item.nom_persona_actual
                      }}
                    </div>
                  </template>
                  <template v-slot:[`item.fecha_persona_actual`]="{ item }">
                    {{
                      item.fecha_persona_actual === null
                        ? ""
                        : formatoFechaSpanish(item.fecha_persona_actual)
                    }}
                  </template>
                  <template v-slot:[`item.estado`]="{ item }">
                    <div v-if="item.estado == 'A'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            icon
                            dark
                            color="success"
                            v-bind="attrs"
                            v-on="on"
                            @click="deleteItemCupo(item)"
                          >
                            <v-icon x-small>check</v-icon>
                          </v-btn>
                        </template>
                        <span>Desactivar Cupo</span>
                      </v-tooltip>
                    </div>
                    <div v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            icon
                            dark
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="deleteItemCupo(item)"
                          >
                            <v-icon x-small>block</v-icon>
                          </v-btn>
                        </template>
                        <span>Activar Cupo</span>
                      </v-tooltip>
                    </div>
                  </template>

                  <template v-slot:[`item.estado`]="{ item }">
                    <div v-if="item.estado == 'A'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            icon
                            dark
                            color="success"
                            v-bind="attrs"
                            v-on="on"
                            @click="deleteItemCupo(item)"
                          >
                            <v-icon x-small>check</v-icon>
                          </v-btn>
                        </template>
                        <span>Desactivar cupo</span>
                      </v-tooltip>
                    </div>
                    <div v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            icon
                            dark
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="deleteItemCupo(item)"
                          >
                            <v-icon x-small>block</v-icon>
                          </v-btn>
                        </template>
                        <span>Activar Cupo</span>
                      </v-tooltip>
                    </div>
                    <div v-if="item.estado == 'A'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            icon
                            dark
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="activarDialogNuevoCargo(item)"
                          >
                            <v-icon x-small>fa-solid fa-arrows-down-to-people</v-icon>
                          </v-btn>
                        </template>
                        <span>Cambiar de cupo</span>
                      </v-tooltip>
                    </div>
                    
                  </template>

                  <template v-slot:no-data>
                    <span>No se encontraron registros</span>
                  </template>
                </v-data-table>
              </v-sheet>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <asignar-cargo-dialog
    v-model="dialogFormCargosAntiguos"
    :descripcion="'Asignación de parámetros de un Cargo Anterior para '+descripcion"
    :label="'Cargo Anterior'"
    :dtCargos="dtCargos"
    :cupo="cupo"   
    @asignar-cargo="asignarCargoAnteriorFunction"
  />

  <asignar-cargo-dialog
    v-model="dialogFormNuevoCargo"
    :descripcion="'Cambio de cargo para el cupo'"
    :label="'Nuevo Cargo'"
    :dtCargos="dtCargos"
    :cupo="1"   
    @asignar-cargo="asignarNuevoCargo"
  />
      

      <v-dialog dense v-model="dialogCentroCosto" max-width="500px">
        <v-card ref="formCentroCosto">
          <v-card-title>
            <span class="headline">Datos Centro de Costo</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_centro_costo"
                    v-model="id_centro_costo"
                    :items="CentroCostosList"
                    :readonly="editedIndexCco"
                    :rules="[]"
                    :error-messages="errorMessagesCentroCosto"
                    item-text="descripcion"
                    item-value="id"
                    label="Centro de Costo"
                    required
                  ></v-autocomplete>

                  <v-text-field
                    outlined
                    dense
                    ref="porcentaje"
                    v-model="porcentaje"
                    :rules="[$rules.numero, $rules.requerido]"
                    :error-messages="errorMessagesCentroCosto"
                    label="Porcentaje"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeCentroCosto"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="guardarCentroCosto"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogBorrarCentroCosto" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción borrará la asignación de Centro de Costo al
            cargo.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogBorrarCentroCosto = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" text @click="eliminarCentroCosto()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogBorrarCupo" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estadoCupo == "A" ? "desactivará" : "activará" }} el
            cupo para el cargo seleccionado, y si está asignado a una persona, quitará esta asignación.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogBorrarCupo = false"> Cancelar </v-btn>

            <div v-if="estadoCupo == 'A'">
              <v-btn color="primary" text @click="desactivarCupo()">
                Continuar
              </v-btn>
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activarCupo()">
                Continuar
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCupo" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text>
            Esta acción añadirá un nuevo cupo al cargo seleccionado.
          </v-card-text>
          <v-container>
            <v-dialog
              ref="dialogFecha"
              v-model="modalFecha"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  type="date"
                  readonly
                  dense
                  ref="fechaCupo"
                  v-model="fechaCupo"
                  :rules="[$rules.requerido]"
                  @click="modalFecha = true"
                  :error-messages="errorMessagesCupo"
                  label="Fecha de Creación de Cupo"
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="fechaCupo" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancelFecha">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="setFecha(date)"> OK </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogCupo = false"> Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarCupo()">
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

import AsignarCargoDialog from "@/components/Cupo/AsignarCargoDialog.vue";


export default {
  components: {
    AsignarCargoDialog,
  },
  data() {
    return {
      width: 0,
      height: 0,
      //Declaración de variables globales
      usuario: this.$store.state.usuario.user,
      //Declaración de arrays
      dtCargos: [],
      dtCargosLoad: true,
      dtCentroCostos: [],
      dtCupos: [],
      dtUniformes: [],
      areaList: [],
      subareaList: [],
      areaPresupList: [],
      CentroCostosList: [],
      //Declaración de variables de Dialog
      dialogForm: false,
      dialogFormCupos: false,
      dialogFormCargosAntiguos: false,
      dialogFormNuevoCargo: false,
      dialogFormCentroCostos: false,
      dialogFormUniformes: false,
      dialogCargaExcel: false,
      dialogActivacion: false,
      dialogCentroCosto: false,
      dialogCupo: false,
      dialogBorrarCentroCosto: false,
      dialogBorrarCupo: false,

      modalFecha: false,
      //Declaración de variables de formulario
      id: "",
      id_cupo: "",
      id_antiguo_cargo: "1",
      fechaCupo: "",
      codigo: "",
      cupo: 0,
      nivel: "",
      base_premio: "",
      descripcion: "",
      salario_ref: "",
      id_area: "",
      id_subarea: "",
      id_area_presupuesto: "",
      estado: "",
      estadoCupo: "",
      porcentajeCco: "",
      porcentaje: 100,
      id_centro_costo: "",
      file: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      selected: [2],
      items: [
        {
          action: "15 min",
          headline: "Brunch this weekend?",
          subtitle: `I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
          title: "Ali Connors",
        },
        {
          action: "2 hr",
          headline: "Summer BBQ",
          subtitle: `Wish I could come, but I'm out of town this weekend.`,
          title: "me, Scrott, Jennifer",
        },
        {
          action: "6 hr",
          headline: "Oui oui",
          subtitle: "Do you have Paris recommendations? Have you ever been?",
          title: "Sandra Adams",
        },
        {
          action: "12 hr",
          headline: "Birthday gift",
          subtitle:
            "Have any ideas about what we should get Heidi for her birthday?",
          title: "Trevor Hansen",
        },
        {
          action: "18hr",
          headline: "Recipe to try",
          subtitle:
            "We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
          title: "Britta Holt",
        },
      ],

      //Declaración de variables de tabla
      headers: [
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Descripción",
          value: "descripcion",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Nivel",
          value: "nivel",
          align: "center",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Base de premio",
          value: "base_premio",
          align: "center",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Area",
          value: "area",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Subárea",
          value: "subarea",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Centro de Costo",
          value: "centro_costo",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Cupos habilitados",
          value: "cupo",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },

        {
          text: "Activo",
          sortable: false,
          filter: this.filtroEstado,
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-3",
        },
      ],

      headersCentroCosto: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Centro de Costo",
          value: "codigo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "centro_costo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Porcentaje",
          value: "porcentaje",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
      ],
      headersUniforme: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Centro de Costo",
          value: "codigo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "centro_costo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Porcentaje",
          value: "porcentaje",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
      ],
      headersCupo: [
        {
          text: "Activo",
          value: "estado",
          sortable: false,
          width: "5%",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "No. Cupo",
          value: "numero",
          class: "primary white--text text-subtitle-2",
          width: "5%",
        },

        {
          text: "Persona Asignada",
          value: "nom_persona_actual",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha de asignación",
          value: "fecha_persona_actual",
          class: "primary white--text text-subtitle-2",
          width: "10%",
        },
      ],
      searchParamCodigo: "",
      searchParamDescripcion: "",
      searchParamEstado: "A",
      esEditado: false,
      editarCodigo: false,
      editarCodigoCentroCosto: false,
      editedIndexCco: false,
      inactivos: true,
      mostrarErrores: false,
      mostrarBusquedas: true,
      //variables de errrores
      valida: 0,
      errorMessages: "",
      errorMessagesCentroCosto: "",
      errorMessagesCupo: "",
      error: "",
      load:false,
      cupoObj: {},
      //variables de tamaño de pantalla
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        nivel: this.nivel,
        base_premio: this.base_premio,
        descripcion: this.descripcion,
        salario_ref: this.salario_ref,
        id_area: this.id_area,
        id_subarea: this.id_subarea,
        id_area_presupuesto: this.id_area_presupuesto,
      };
    },
    formCentroCosto() {
      return {
        id_centro_costo: this.id_centro_costo,
        porcentaje: this.porcentaje,
      };
    },
    formCupo() {
      return {
        fechaCupo: this.fechaCupo,
      };
    },
  },

  watch: {
    dialogForm(val) {
      val || this.cerrar();
    },

    name() {
      this.errorMessages = "";
      this.errorMessagesCentroCosto = "";
      this.errorMessagesCupo = "";
    },
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')
    this.$store.dispatch("actualizarTitulo", "Cargo");
    this.listar();
    this.selectArea();
    this.selectAreaPresup();
    this.selectCentroCosto();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },
  mounted() {
    this.getDimensions();
  },

  methods: {
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    listar() {
      let me = this;
      me.dtCargosLoad = true;
      axios
        .get("api/cargos/listarA_I/" + true)
        .then(function (response) {
          me.dtCargos = response.data;
          me.dtCargosLoad = false;
        })
        .catch(function (error) {
          me.dtCargosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarOtros() {
      let me = this;
      me.dtCargosLoad = true;
      axios
        .get("api/cargos/listarA_I/" + true)
        .then(function (response) {
          me.dtCargosOtros = response.data;
        })
        .catch(function (error) {
          me.dtCargosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarCargoCentro() {
      let me = this;
      axios
        .get("api/cargo_centros/listarCargoCentro/" + this.id)
        .then(function (response) {
          me.dtCentroCostos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarCupos() {
      let me = this;
      axios
        .get("api/cupos/listar/" + this.id)
        .then(function (response) {
          me.dtCupos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarUniformes() {
      let me = this;
      axios
        .get("api/uniformes/listarPorCargo/" + this.id)
        .then(function (response) {
          me.dtUniformes = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarPersonasSinCupos() {
      let me = this;
      axios
        .get("api/personas/listarSinCupos/" + this.id)
        .then(function (response) {
          me.dtCupos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectSubarea() {
      let me = this;
      axios
        .get("api/subareas/select/" + this.id_area)
        .then(function (response) {
          me.subareaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectArea() {
      let me = this;
      axios
        .get("api/areas/select")
        .then(function (response) {
          me.areaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectAreaPresup() {
      let me = this;
      axios
        .get("api/area_presupuestos/select")
        .then(function (response) {
          me.areaPresupList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCentroCosto() {
      let me = this;
      axios
        .get("api/centro_costos/select")
        .then(function (response) {
          me.CentroCostosList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.searchParamEstado = this.inactivos ? "A" : "";
      //this.listar();
    },

    abrirDialogActivacion(item) {
      this.id = item.id;
      this.dialogActivacion = true;
      this.estado = item.estado;
    },

    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    cerrarCarga() {
      this.dialogCargaExcel = false;
      this.limpiarCargaExcel();
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },
    closeCentroCosto() {
      this.dialogCentroCosto = false;
      this.limpiarCentroCosto();
    },
    editar(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.id_antiguo_cargo = item.id_antiguo_cargo;
      this.cupo = item.cupo;
      this.porcentajeCco = item.porcentaje;
      this.nivel = item.nivel;
      this.base_premio = item.base_premio;
      this.descripcion = item.descripcion;
      this.salario_ref = item.salario_ref;
      this.id_area = item.id_area;
      this.id_subarea = item.id_subarea;
      this.id_area_presupuesto = item.id_area_presupuesto;
      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogForm = true;
      //debe agregarse $nextTick para los elementos no renderizados hastas su llamada

      this.selectSubarea();
      this.listarCargoCentro();
      this.listarCupos();
    },
    editarUniformes(item) {
      if (item != undefined) {
        this.id = item.id;

        this.descripcion = item.descripcion;
      }

      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogFormUniformes = true;
      this.listarUniformes();
    },
    editarCupos(item) {
      if (item != undefined) {
        this.id = item.id;
        this.cupo = item.cupo;
        this.descripcion = item.descripcion;
      }

      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogFormCupos = true;
      this.listarCupos();
    },
    editarAntiguoCargo() {
      this.dialogFormCargosAntiguos = true;
    },
    editarCentroCostos(item) {
      if (item != undefined) {
        this.id = item.id;
        this.descripcion = item.descripcion;
      }
      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogFormCentroCostos = true;
      this.listarCargoCentro();
    },

    agregar() {
      this.editarCodigo = true;
      this.dialogForm = true;
    },
    agregarCentroCosto() {
      this.editarCodigoCentroCosto = true;
      this.dialogCentroCosto = true;
    },
    agregarCupo() {
      this.editarCupo = true;
      this.dialogCupo = true;
    },

    cerrar() {
      this.dialogForm = false;
      this.limpiar();
    },
    cerrarCupo() {
      this.dialogFormCupos = false;
      this.listar();
    },
    cerrarCentroCosto() {
      this.dialogFormCentroCostos = false;
      this.listar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.nivel = "";
      this.base_premio = "";
      this.descripcion = "";
      this.salario_ref = "";
      this.id_area = "";
      this.id_subarea = "";
      this.id_area_presupuesto = "";
      this.esEditado = false;
    },
    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },
    limpiarCentroCosto(item) {
      this.id_centro_costo = "";
      this.id_cargo = "";
      this.porcentaje = 100;
      this.editedIndexCco = false;
    },

    guardar() {
      if (this.validar(this.form) > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.esEditado) {
        //codigo para editar
        let me = this;
        axios
          .put("api/cargos/actualizar", {
            id: me.id,
            codigo: me.codigo,
            nivel: me.nivel,
            base_premio: me.base_premio,
            descripcion: me.descripcion,
            id_subarea: me.id_subarea,
            id_area_presupuesto: me.id_area_presupuesto,

            salario_ref: me.salario_ref,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/cargos/crear", {
            codigo: me.codigo,
            nivel: me.nivel,
            base_premio: me.base_premio,
            descripcion: me.descripcion,
            id_subarea: me.id_subarea,
            id_area_presupuesto: me.id_area_presupuesto,

            salario_ref: me.salario_ref,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    exportarExcel() {
      let me = this;
      me.load = true;
      axios({
        url: "api/cargos/ExportarCargos",
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Reporte de Cargos Vigentes - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/cargos/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.cerrarCarga();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    validar(formulario) {
      this.valida = 0;

      Object.keys(formulario).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarCentroCosto() {
      this.validaCentroCosto = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      Object.keys(this.formCentroCosto).forEach((f) => {
        this.$refs[f].validate(true);
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaCentroCosto += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaCentroCosto += 1;
        }
      });
      return this.validaCentroCosto;
    },

    activar() {
      let me = this;
      axios
        .put("api/cargos/activar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    desactivar() {
      let me = this;
      axios
        .put("api/cargos/desactivar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    deleteItemCentroCosto(item) {
      this.id_centro_costo = item.id_centro_costo;
      this.dialogBorrarCentroCosto = true;
    },
    deleteItemCupo(item) {
      this.id_cupo = item.id;
      this.estadoCupo = item.estado;
      this.dialogBorrarCupo = true;
    },

    eliminarCentroCosto() {
      let me = this;
      axios
        .delete(
          "api/cargo_centros/EliminarCargoCentro/" +
            me.id +
            "/" +
            me.id_centro_costo,
          {}
        )
        .then(function (response) {
          me.listarCargoCentro();

          me.$store.dispatch("setSnackbar", {
            text: "Centro de Costo eliminado exitosamente.",
            color: "success",
          });
          me.dialogBorrarCentroCosto = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    desactivarCupo() {
      let me = this;
      axios
        .put(
          "api/cupos/desactivar/" + me.id_cupo + "/" + me.usuario,{}
        )
        .then(function (response) {
          me.listarCupos();
          me.$store.dispatch("setSnackbar", {
            text: me.response.data,
            color: "success",
          });
          me.dialogBorrarCupo = false;
        })
        .catch(function (error) {
          me.dialogBorrarCupo = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    activarCupo() {
      let me = this;
      axios
        .put(
          "api/cupos/activar/" + me.id_cupo + "/" + me.usuario,

          {}
        )
        .then(function (response) {
          me.listarCupos();
          me.$store.dispatch("setSnackbar", {
            text: "Cupo activado exitosamente. ",
            color: "success",
          });
          me.dialogBorrarCupo = false;
        })
        .catch(function (error) {
          me.dialogBorrarCupo = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    guardarCentroCosto() {
      if (this.validar(this.formCentroCosto) > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndexCco) {
        let me = this;
        axios
          .put("api/cargo_centros/actualizar", {
            id_cargo: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentaje,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCargoCentro();
            me.limpiarCentroCosto();
            me.listar();
            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/cargo_centros/crear", {
            id_cargo: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentaje,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCargoCentro();
            me.limpiarCentroCosto();
            me.listar();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarCupo() {
      let me = this;
      if (this.validar(this.formCupo) > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      axios
        .post("api/cupos/crear", {
          id_cargo: me.id,
          fecha_creacion: me.fechaCupo,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.dialogCupo = false;
          me.listarCupos();
          me.listar();

          me.$store.dispatch("setSnackbar", {
            text: "Cupo agregado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    activarDialogNuevoCargo(item) {
      this.dialogFormNuevoCargo = true;
      this.cupoObj = item;
    },

    asignarNuevoCargo(idCargo) {
      let me = this;

      axios
        .put(
          "api/cargos/SetCargoNuevo/" +
            me.cupoObj.id +
            "/" +
            idCargo +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.dialogFormNuevoCargo = false;

          me.listarCupos();

          me.$store.dispatch("setSnackbar", {
            text: "Cupo cambiado a nuevo cargo exitosamente",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    asignarCargoAnteriorFunction(idCargo) {
      let me = this;

      axios
        .put(
          "api/cargos/SetCargoAnterior/" +
            me.id +
            "/" +
            idCargo +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.dialogFormCargosAntiguos = false;

          me.listar();

          me.$store.dispatch("setSnackbar", {
            text: "Asignación de cargo anterior realizada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    filtroCodigo(value) {
      // Si el filtro no tiene valor, evitamos el filtro.
      if (!this.searchParamCodigo) {
        return true;
      }
      // Verificar el valor del ciclo actual, si contiene parcialmente la palabra buscada
      return value.toLowerCase().includes(this.searchParamCodigo.toLowerCase());
    },
    filtroDescripcion(value) {
      // Si el filtro no tiene valor, evitamos el filtro.
      if (!this.searchParamDescripcion) {
        return true;
      }
      // Verificar el valor del ciclo actual, si contiene parcialmente la palabra buscada
      return value
        .toLowerCase()
        .includes(this.searchParamDescripcion.toLowerCase());
    },
    filtroEstado(value) {
      // Si el filtro no tiene valor, evitamos el filtro.
      if (!this.searchParamEstado) {
        return true;
      }
      // Verificar el valor del ciclo actual, si contiene parcialmente la palabra buscada
      return value.toLowerCase().includes(this.searchParamEstado.toLowerCase());
    },

    cancelFecha() {
      let me = this;
      me.fechaCupo = this.modalFecha = false;
      //poner fecha actual
      me.fechaCupo = this.$formatoFecha(new Date());
    },
    setFecha() {
      let me = this;
      //validar fecha no mayor a 30 dias
      let fecha = new Date(me.fechaCupo);
      let fechaActual = new Date();
      let fechaMaxima = new Date();
      let fechaAnt = new Date();
      fechaMaxima.setDate(fechaActual.getDate());

      if (fecha > fechaMaxima) {
        this.$store.dispatch("setSnackbar", {
          text: "La fecha no puede ser mayor a la fecha actual.",
          color: "error",
        });
        return;
      }

      //me.fechaCupo=this.$formatoFechaSpanish(me.fechaCupo);
      me.modalFecha = false;
    },

    formatoFechaSpanish(fecha) {
      var anio = fecha.substring(6, 6);
      var mes = fecha.substring(3, 2);
      var dia = fecha.substring(0, 2);
      if (fecha != "") {
        try {
          var m = new Date(fecha);
          var dateString =
            ("0" + m.getUTCDate()).slice(-2) +
            "-" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) +
            "-" +
            m.getUTCFullYear();
          return dateString;
        } catch (error) {
          console.error(error);
        }
      } else {
        return "";
      }
    },
  },
};
</script>
